export enum ActionType {
  PIDF_LIST = "PIDF_LIST",
}

export interface IPidfList {
  type: ActionType.PIDF_LIST;
  payload: any[];
}
export type Action = IPidfList;
